import Component from 'antd/es/select';
import 'antd/lib/select/style';
export default Component;
